
import {gsap} from 'gsap';

// ─────────────────────────────────────────────────────────────────────────────
// MENU LETTER HOVER EFFECT  →  sub-menu overlay (burger)
// Al hover su una voce: compare un quadrato rosa in posizione random,
// le lettere coperte dal quadrato prendono un pink diverso, le altre bianco.
// ─────────────────────────────────────────────────────────────────────────────
function initMenuLetterEffect() {
    document.querySelectorAll([
        '.sub-menu > ul > li > a',
        '.sub-menu > ul > li > span',
        '.header__nav-submenu li > a',
        '.header__nav-submenu li > span'
    ].join(',')).forEach(function (el) {
        if (el.dataset.mhlReady) {
            return null;
        }// evita doppia inizializzazione
        el.dataset.mhlReady = '1';

        // Preserva l'icona chevron (se presente)
        const icon = el.querySelector('i');
        const rawTxt = el.textContent.trim();
        if (!rawTxt) {
            return null;
        }

        // Ricostruisce il contenuto: una <span class="mhl"> per ogni lettera
        el.innerHTML = '';
        el.style.position = 'relative';
        el.style.display = 'inline-block';

        const letters = [];
        rawTxt.split('').forEach(function (ch) {
            const s = document.createElement('span');
            s.className = 'mhl';
            s.textContent = (ch === ' ') ? ' ' : ch;
            s.style.cssText = 'display:inline-block;position:relative;z-index:2;transition:color 0.08s;font-size:inherit;';
            el.appendChild(s);
            letters.push(s);
        });

        // Reinserisce l'icona chevron in fondo
        if (icon) {
            icon.style.position = 'relative';
            icon.style.zIndex = '2';
            el.appendChild(icon);
        }
    });
}

// ─────────────────────────────────────────────────────────────────────────────
// MENU CURSOR — quadratino rosa che segue il mouse quando il menu è aperto.
// Piccolo a riposo, grande al hover sulle voci.
// ─────────────────────────────────────────────────────────────────────────────
function initMenuCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) {
        return null;
    }
    const cursor = document.getElementById('menu-cursor');
    const navWrapper = document.querySelector('.header__nav-wrapper');
    if (!cursor || !navWrapper) {
        return null;
    }

    const LETTER_COLOR = '#FF4BFF'; // stesso viola di initMenuLetterEffect

    // Aggiorna posizione ad'ogni mousemove (solo se menu aperto)
    document.addEventListener('mousemove', function (e) {
        if (!navWrapper.classList.contains('open')) {
            return null;
        }

        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';

        // Colora le lettere .mhl che si sovrappongono al cursore
        const cr = cursor.getBoundingClientRect();
        navWrapper.querySelectorAll('.mhl').forEach(function (letter) {
            const r = letter.getBoundingClientRect();
            const overlaps = r.left < cr.right && r.right > cr.left &&
                r.top < cr.bottom && r.bottom > cr.top;
            letter.style.color = overlaps ? LETTER_COLOR : '';
        });
    });

    // Mostra/nascondi al toggle del menu tramite MutationObserver
    new MutationObserver(function () {
        if (navWrapper.classList.contains('open')) {
            cursor.classList.add('is-visible');
        } else {
            cursor.classList.remove('is-visible', 'is-large', 'is-large--sub');
        }
    }).observe(navWrapper, {attributes: true, attributeFilter: ['class']});

    // Menu principale — grande
    const mainTargets = navWrapper.querySelectorAll([
        '.sub-menu > ul > li > a',
        '.sub-menu > ul > li > span',
        '.header__contact-link'
    ].join(','));

    mainTargets.forEach(function (el) {
        el.addEventListener('mouseenter', function () {
            cursor.classList.add('is-large');
        });
        el.addEventListener('mouseleave', function () {
            cursor.classList.remove('is-large');
        });
    });

    // Submenu — più piccolo
    const subTargets = navWrapper.querySelectorAll([
        '.header__nav-submenu li > a',
        '.header__nav-submenu li > span'
    ].join(','));

    subTargets.forEach(function (el) {
        el.addEventListener('mouseenter', function () {
            cursor.classList.add('is-large--sub');
        });
        el.addEventListener('mouseleave', function () {
            cursor.classList.remove('is-large--sub');
        });
    });
}

// ─────────────────────────────────────────────────────────────────────────────
// NAVIGAZIONE MENU — submenu overlay (click), closerX, subnav mobile, burger,
// timeline GSAP di apertura/chiusura, toggleMenuOpenClose.
// `activeHeadrooms` viene passato dal chiamante: il toggle congela/scongela
// gli Headroom registrati altrove.
// ─────────────────────────────────────────────────────────────────────────────
function initNavigationMenu(activeHeadrooms) {

    // Submenu overlay — apertura al CLICK (non più hover), su tutte le viewport.
    // Click sulla voce padre apre/chiude il relativo submenu; le voci sorelle
    // dello stesso livello si chiudono, mentre gli antenati restano aperti
    // (così i submenu annidati funzionano correttamente).
    let closeAllSubmenus = function () {
    };
    (function () {
        const navWrapper = document.querySelector('.header__nav-wrapper');
        if (!navWrapper) {
            return null;
        }

        const items = navWrapper.querySelectorAll('.sub-menu .header__item-has-submenu');

        function closeAll() {
            items.forEach(function (li) {
                li.classList.remove('is-open');
            });
        }

        closeAllSubmenus = closeAll;

        function closeSiblings(li) {
            const parentUl = li.parentElement;
            if (!parentUl) {
                return null;
            }
            Array.prototype.forEach.call(parentUl.children, function (sib) {
                if (sib !== li) {
                    sib.classList.remove('is-open');
                    sib.querySelectorAll('.header__item-has-submenu.is-open')
                        .forEach(function (n) {
                            n.classList.remove('is-open');
                        });
                }
            });
        }

        function animateSubmenuChildren(li) {
            if (window.innerWidth <= 992) {
                return null;
            }
            const children = li.querySelectorAll(
                ':scope > .header__nav-submenu-wrapper > ul > li'
            );
            if (!children.length) {
                return null;
            }
            gsap.fromTo(children,
                {opacity: 0, y: 20},
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.4,
                    ease: 'power2.out',
                    stagger: 0.07,
                    delay: 0.15,
                    clearProps: 'transform'
                }
            );
        }

        items.forEach(function (li) {
            const trigger = li.querySelector(':scope > a, :scope > span');
            if (!trigger) {
                return null;
            }
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                if (li.classList.contains('is-open')) {
                    // Desktop: già aperto, non si può chiudere cliccando su se stesso
                    if (window.innerWidth > 992) {
                        return;
                    }
                    li.classList.remove('is-open');
                    li.querySelectorAll('.header__item-has-submenu.is-open')
                        .forEach(function (n) {
                            n.classList.remove('is-open');
                        });
                } else {
                    closeSiblings(li);
                    li.classList.add('is-open');
                    animateSubmenuChildren(li);
                }
            });
        });

        // Chiude tutti i submenu alla chiusura del menu (X)
        if (document.querySelector('#closerX')) {
            document.querySelector('#closerX').addEventListener('click', closeAll);
        }
    })();

    // Chiudi menu mobile con la X
    const closerX = $('#closerX');
    closerX.click(function () {
        toggleMenuOpenClose();
    });

    // Sub-nav mobile toggle (MKT · Clark · Digital Adventures)
    document.querySelectorAll('.subnav-mobile__toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
            btn.closest('.subnav-mobile').classList.toggle('is-open');
        });
    });
    document.querySelectorAll('.subnav-mobile__overlay').forEach(function (overlay) {
        overlay.addEventListener('click', function () {
            overlay.closest('.subnav-mobile').classList.remove('is-open');
        });
    });

    // Burger menu — apri/chiudi menu mobile
    let burgerButton = $('.burger-button');
    burgerButton.on('click', function (e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    // ── Animazione menu (GSAP) ────────────────────────────────────────────────
    // Effetto in 3 fasi (come .nav-effect su snauwaert):
    //   1. La striscia .nav-effect entra da destra (right → 0)
    //   2. si espande in altezza dal centro (height → 100vh)
    //   3. le voci del menu e il footer compaiono in stagger
    // La chiusura riproduce l'animazione al contrario.
    let menuTimeline = null;

    function buildMenuTimeline() {
        const navWrapper = document.querySelector('.header__nav-wrapper');
        if (!navWrapper) {
            return null;
        }

        const navEffect = navWrapper.querySelector('.nav-effect');
        const mainItems = navWrapper.querySelectorAll('.sub-menu > ul > li');
        const bottomItems = navWrapper.querySelectorAll(
            '#closerX-box, .link-social-header a, .header__contact-link'
        );

        const tl = gsap.timeline({
            paused: true,
            onComplete: function () {
                navWrapper.style.backgroundColor = '#AC214A';
            },
            onReverseComplete: function () {
                $('.header__nav-wrapper').removeClass('open');
            }
        });

        // Stato iniziale esplicito: voci nascoste e striscia fuori schermo.
        // (Evita le ambiguità di immediateRender di .from() su timeline in pausa.)
        gsap.set(mainItems, {opacity: 0, y: 50});
        gsap.set(bottomItems, {opacity: 0, y: 25});
        if (navEffect) {
            gsap.set(navEffect, {right: '-200vw', height: 20});
        }

        if (navEffect) {
            tl.to(navEffect, {right: 0, duration: 0.55, ease: 'power2.out'})
                .to(navEffect, {height: '100vh', duration: 0.35, ease: 'power2.inOut'});
        }

        tl.to(mainItems, {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out',
            stagger: 0.06,
            clearProps: 'transform,translate,rotate,scale'
        }, '-=0.3')
            .to(bottomItems, {
                y: 0,
                opacity: 1,
                duration: 0.4,
                ease: 'power2.out',
                stagger: 0.04
            }, '-=0.3');

        return tl;
    }

    menuTimeline = buildMenuTimeline();

    // Blocca tutti i touch/wheel event sul documento quando il menu è aperto.
    // Lo scroll interno al nav-wrapper funziona perché stopNavWrapperProp
    // ferma la propagazione prima che arrivi al documento.
    function preventAllScroll(e) {
        e.preventDefault();
    }

    const navWrapperEl = document.querySelector('.header__nav-wrapper');
    function stopNavWrapperProp(e) {
        e.stopPropagation();
    }

    function toggleMenuOpenClose() {
        const body = $('body');
        let headerNavWrapper = $('.header__nav-wrapper');

        if (!menuTimeline) {
            return null;
        }

        if (headerNavWrapper.hasClass('open')) {
            // Chiusura — .open viene rimosso in onReverseComplete
            body.removeClass('no-scroll-y');
            document.removeEventListener('touchmove', preventAllScroll);
            document.removeEventListener('wheel', preventAllScroll);
            if (navWrapperEl) {
                navWrapperEl.removeEventListener('touchmove', stopNavWrapperProp);
                navWrapperEl.removeEventListener('wheel', stopNavWrapperProp);
            }
            // Rimuove il background inline prima del reverse così il nav-effect è visibile
            headerNavWrapper[0].style.backgroundColor = '';
            closeAllSubmenus();
            activeHeadrooms.forEach(function (hr) {
                hr.unfreeze();
            });
            if (typeof lenis !== 'undefined') {
                lenis.start();
            }
            menuTimeline.reverse();
        } else {
            // Apertura
            body.addClass('no-scroll-y');
            document.addEventListener('touchmove', preventAllScroll, {passive: false});
            document.addEventListener('wheel', preventAllScroll, {passive: false});
            if (navWrapperEl) {
                navWrapperEl.addEventListener('touchmove', stopNavWrapperProp, {passive: true});
                navWrapperEl.addEventListener('wheel', stopNavWrapperProp, {passive: true});
            }
            headerNavWrapper.addClass('open');
            activeHeadrooms.forEach(function (hr) {
                hr.freeze();
            });
            if (typeof lenis !== 'undefined') {
                lenis.stop();
            }
            menuTimeline.play().then(function () {
                document.querySelectorAll('.sub-menu .active').forEach(function (activeEl) {
                    let ancestor = activeEl.closest('.header__item-has-submenu');
                    while (ancestor) {
                        ancestor.classList.add('is-open');
                        ancestor = ancestor.parentElement ? ancestor.parentElement.closest('.header__item-has-submenu') : null;
                    }
                });
            });
        }
    }
}

export {initMenuLetterEffect, initMenuCursor, initNavigationMenu};
